import { ValueLabel } from '../common';
import { IRequestStatus } from '.';

export interface ISearchableProperty extends ValueLabel<keyof IRequestStatus> {
  searchable: boolean;
}

export interface ISearchableLegacyProperty extends ValueLabel<keyof any> {
  searchable: boolean;
}

export const properties: ISearchableProperty[] = [
  { value: 'action', label: 'Action', searchable: false },
  { value: 'requestId', label: 'Request ID', searchable: true },
  { value: 'deaNumbers', label: 'DEA Numbers', searchable: true },
  { value: 'reqType', label: 'Request Type', searchable: true },
  { value: 'reqRole', label: 'Role', searchable: false },
  { value: 'createdAt', label: 'Created Date', searchable: true },
  { value: 'status', label: 'Status', searchable: true },
  { value: 'beneficiaryEmail', label: 'Subscriber Information', searchable: false },
  { value: 'subscriberAccountId', label: 'Subscriber Account ID', searchable: false },
  { value: 'requestorEmail', label: 'Requester', searchable: true },
  { value: 'activeApproverEmail', label: 'Approver', searchable: false },
  { value: 'approverComments', label: 'Approver Comments', searchable: false },
  // { value: 'beneficiaryEmail', label: 'Beneficiary', searchable: false },
  // { value: 'sailpointCaseId', label: 'Sailpoint Case ID', searchable: true },
];

// export const legacyProperties: ISearchableLegacyProperty[] = [
//   { value: 'action', label: 'Action', searchable: false },
//   { value: 'requestId', label: 'Request ID', searchable: true },
//   { value: 'deaNumbers', label: 'DEA Numbers', searchable: true },
//   { value: 'reqType', label: 'Request Type', searchable: true },
//   { value: 'reqRole', label: 'Role', searchable: false },
//   { value: 'createdAt', label: 'Created Date', searchable: true },
//   { value: 'status', label: 'Status', searchable: true },
//   { value: 'beneficiaryEmail', label: 'Subscriber Information', searchable: false },
//   { value: 'subscriberAccountId', label: 'Subscriber Account ID', searchable: false },
//   { value: 'requestorEmail', label: 'Requester', searchable: true },
//   { value: 'activeApproverEmail', label: 'Approver', searchable: false },
//   { value: 'approverComments', label: 'Approver Comments', searchable: false },
//   // { value: 'beneficiaryEmail', label: 'Beneficiary', searchable: false },
//   // { value: 'sailpointCaseId', label: 'Sailpoint Case ID', searchable: true },
// ];
